(function () {
  function closeTip(tip, btn){ if(!tip) return; tip.hidden = true; if(btn) btn.setAttribute('aria-expanded','false'); }
  function openTip(tip, btn){ tip.hidden = false; btn.setAttribute('aria-expanded','true');
    tip.querySelector('.veil-tooltip-close')?.focus(); }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-veil-trigger]');
    const allTips = document.querySelectorAll('.veil-tooltip');
    const allBtns = document.querySelectorAll('[data-veil-trigger]');

    // klikk utenfor → lukk
    if (!btn && !e.target.closest('.veil-tooltip')) {
      allTips.forEach((t,i)=>closeTip(t, allBtns[i])); return;
    }
    if (!btn) return;

    const id  = btn.getAttribute('data-veil-trigger');
    const tip = document.getElementById(id);

    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    allTips.forEach((t,i)=>closeTip(t, allBtns[i]));
    if (!isOpen) openTip(tip, btn);
  });

  // lukk med ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.veil-tooltip').forEach(t => t.hidden = true);
      document.querySelectorAll('[data-veil-trigger]').forEach(b => b.setAttribute('aria-expanded','false'));
    }
  });

  // lukk med kryss
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.veil-tooltip-close');
    if (!closeBtn) return;
    const tip = closeBtn.closest('.veil-tooltip');
    const trigger = document.querySelector('[data-veil-trigger="'+ tip.id +'"]');
    closeTip(tip, trigger);
  });
})();